var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsPaperclipAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4296 11.0551L12.1764 3.35152C13.4524 2.0827 15.4574 2.0827 16.6423 3.35152C17.9182 4.62035 17.9182 6.61422 16.6423 7.79241L9.5334 14.8616C8.622 15.7679 7.16378 15.7679 6.34352 14.8616C5.43213 13.9553 5.43213 12.5052 6.34352 11.6895L11.5385 6.52359C11.7207 6.34232 11.9942 6.34232 12.1764 6.52359C12.3587 6.70485 12.3587 6.97674 12.1764 7.158L6.9815 12.3239C6.43466 12.8677 6.43466 13.6834 6.9815 14.2272C7.52833 14.771 8.34859 14.771 8.89542 14.2272L16.0043 7.158C16.9157 6.25169 16.9157 4.80161 16.0043 3.98593C15.0929 3.17026 13.6347 3.07963 12.8144 3.98593L5.06757 11.6895C3.79162 12.9583 3.79162 14.9522 5.06757 16.1304C6.34352 17.3086 8.34859 17.3992 9.5334 16.1304L15.3663 10.3301C15.5486 10.1488 15.822 10.1488 16.0043 10.3301C16.1866 10.5113 16.1866 10.7832 16.0043 10.9645L10.1714 16.7648C8.622 18.3962 6.0701 18.3962 4.4296 16.8555C2.78909 15.2241 2.78909 12.6865 4.4296 11.0551Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsPaperclipAttach);
export default __webpack_public_path__ + "static/media/docs-paperclip-attach.0766b5b8b1a6ec7d55fe6a1e59f6489c.svg";
export { ForwardRef as ReactComponent };